var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPenEdit7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Pen, Edit.7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15471",
    fill: "none",
    stroke: "#0e6cae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11866",
    d: "M11 9.883V13h3.117l6.6-6.492a1 1 0 00.006-1.42l-1.812-1.812a1 1 0 00-1.42.006L11 9.883z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11867",
    d: "M7 13H5a2 2 0 00-2 2h0a2 2 0 002 2h14a2 2 0 012 2h0a2 2 0 01-2 2h-4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11868",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgPenEdit7;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Pen, Edit.7.svg
// module id = 804
// module chunks = 101